import { ButtonLink } from '@/components/ui/Button';
import { StateBlock } from '@/components/ui/StateBlock';
import { Surface } from '@/components/ui/Surface';

export function NotFoundPage() {
  return (
    <div className="centered-page">
      <Surface>
        <StateBlock
          icon="404"
          title="Страница не найдена"
          description="Проверьте адрес — возможно, раздел был перемещён или ссылка устарела."
          action={<ButtonLink to="/transcriptions">К журналу встреч</ButtonLink>}
        />
      </Surface>
    </div>
  );
}
